<template>
  <div>
    <div class="auth-wrap">
      <div class="auth-left">
        <div class="dentaltwin-logo">
          <img
              src="@/assets/images/svg/dentaltwin_logo.svg"
              style="width: 270px; padding-top: 4px"
            />
        </div>
        <div class="auth-left-text">
          <h1>{{ $t(registerTitleKey) }}</h1>
          <p>{{ $t(registerSubKey) }}</p>
        </div>
        <img class="teeth-login" src="@/assets/images/login_logo.png" alt="DentalTwin teeth">
      </div>
      <div class="auth-right">
        <div class="auth-header">
          <img src="@/assets/images/svg/logo.svg" alt="DentalTwin logo">
          <!-- <div class="menu-icon" @click="toggleSidebar">
            <ElementIcon v-bind:icon="'menuIcon'" />
          </div> -->
        </div>
        
        <div class="auth-card">
          <div class="auth-card-header">
            <div>
              <h2>{{ $t('register') }}</h2>
              <h5 v-if="isMobileRegisterText" class="mb-0 text-white">{{ $t("registerAndTryForFree") }}</h5>
            </div>
            <div class="auth-language">
              <ul>
                <Language />
              </ul>
            </div>
          </div>
          <div class="auth-card-body">
            <div class="auth-card-body-content">
              <div v-if="customerId.companyName">
                <h5 class="form-label">{{ $t("referringPartner") }}: {{ customerId.companyName }}</h5>
              </div>
              <!-- <h2>{{ $t('welcomeTo') }} <span>{{ $t('DentalTwin') }}</span></h2> -->
              <p>{{ $t(registerDescriptionKey) }}</p>
              <validation-observer ref="simpleRules">
                <b-form class="auth-login-form mt-2" @submit.prevent>
                  <div class="row">
                    <div class="col-md-6 mb-1">
                      <validation-provider
                        #default="{ errors }"
                        name="First Name"
                        rules="required"
                      >
                        <div class="required-placeholder-input">
                          <input
                            v-model="form.first_name"
                            type="text"
                            class="form-control"
                            :placeholder="$t('firstName')"
                          />
                          <span v-if="!form.first_name" class="required-placeholder-asterisk" :style="getRequiredAsteriskStyle('firstName')">*</span>
                        </div>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </div>
                    <div class="col-md-6 mb-1">
                      <validation-provider
                        #default="{ errors }"
                        name="Last Name"
                        rules="required"
                      >
                        <div class="required-placeholder-input">
                          <input
                            v-model="form.last_name"
                            type="text"
                            class="form-control"
                            :placeholder="$t('lastName')"
                          />
                          <span v-if="!form.last_name" class="required-placeholder-asterisk" :style="getRequiredAsteriskStyle('lastName')">*</span>
                        </div>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </div>
                    <div class="col-md-6 mb-1">
                      <validation-provider
                        #default="{ errors }"
                        name="Company Name"
                        rules="required"
                      >
                        <div class="required-placeholder-input">
                          <input
                            v-model="form.companyName"
                            type="text"
                            class="form-control"
                            :placeholder="$t('companyName')"
                          />
                          <span v-if="!form.companyName" class="required-placeholder-asterisk" :style="getRequiredAsteriskStyle('companyName')">*</span>
                        </div>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </div>
                    <div class="col-md-6 mb-1">
                      <validation-provider
                        #default="{ errors }"
                        name="Address Line 1"
                        rules="required"
                      >
                        <div class="required-placeholder-input">
                          <input
                            v-model="form.addressLine1"
                            type="text"
                            class="form-control"
                            :placeholder="$t('addressLine1')"
                          />
                          <span v-if="!form.addressLine1" class="required-placeholder-asterisk" :style="getRequiredAsteriskStyle('addressLine1')">*</span>
                        </div>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </div>
                    <div class="col-md-6 mb-1">
                      <validation-provider
                        #default="{ errors }"
                        name="ZIP"
                        rules="required"
                      >
                        <div class="required-placeholder-input">
                          <input
                            v-model="form.zipCode"
                            type="text"
                            class="form-control"
                            :placeholder="$t('zip')"
                          />
                          <span v-if="!form.zipCode" class="required-placeholder-asterisk" :style="getRequiredAsteriskStyle('zip')">*</span>
                        </div>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </div>
                    <div class="col-md-6 mb-1">
                      <validation-provider
                        #default="{ errors }"
                        name="City"
                        rules="required"
                      >
                        <div class="required-placeholder-input">
                          <input
                            v-model="form.city"
                            type="text"
                            class="form-control"
                            :placeholder="$t('city')"
                          />
                          <span v-if="!form.city" class="required-placeholder-asterisk" :style="getRequiredAsteriskStyle('city')">*</span>
                        </div>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <validation-provider
                          #default="{ errors }"
                          name="Country"
                          rules="required"
                        >
                          <select class="form-control" v-model="form.country">
                            <option value="">{{ $t("allCountries") }}</option>
                            <option
                              v-for="country in countries"
                              :value="country"
                              :key="country.code"
                            >
                              {{ country.name }}
                            </option>
                          </select>
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                      <validation-provider
                        #default="{ errors }"
                        name="Referring Partner"
                        rules="required"
                      >
                        <MultiSelectInput
                          v-model="customerId"
                          :key="customerId"
                          :options="partners"
                          label="companyName"
                          trackBy="id"
                          :placeholder="$t('referralPartner')"
                          moduleName="customers"
                          :action="'partnerCompanies'"
                          :isDisabled="isCustomerDisabled"
                          :multiple="false"
                          ><template #option="{ props }">
                            <div>
                              <p class="text-dark">
                                {{ props.option.companyName }}
                              </p>
                            </div>
                          </template>
                        </MultiSelectInput>
                        <small class="text-danger">{{ $t(errors[0]) }}</small>
                      </validation-provider>
                      </div>
                    </div>
                    <div class="col-md-6 mb-1">
                      <b-form-group class="m-0">
                        <validation-provider
                          #default="{ errors }"
                          name="Contact Language"
                          rules="required"
                        >
                          <select
                            class="form-control"
                            v-model="form.contactLanguage"
                          >
                            <option
                              v-for="language in languages"
                              :value="language"
                              :key="language"
                            >
                              {{ language }}
                            </option>
                          </select>
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </div>
                    <div class="col-md-6 mb-1">
                      <input
                        v-model="form.phone"
                        type="text"
                        class="form-control"
                        :placeholder="$t('phone')"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6 mb-1">
                      <b-form-group label-for="login-email">
                        <validation-provider
                          #default="{ errors }"
                          name="Email"
                          rules="required|email"
                        >
                          <div class="required-placeholder-input">
                            <input
                              id="email"
                              v-model="form.email"
                              name="title"
                              class="form-control"
                              type="text"
                              :placeholder="$t('email')"
                            />
                            <span v-if="!form.email" class="required-placeholder-asterisk text-danger" :style="getRequiredAsteriskStyle('email')">*</span>
                          </div>
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </div>
                    <div class="col-md-6 mb-1">
                      <b-form-group>
                        <validation-provider
                          #default="{ errors }"
                          name="Password"
                          rules="required"
                        >
                          <b-input-group
                            class="input-group-merge required-placeholder-input"
                            :class="errors.length > 0 ? 'is-invalid' : null"
                          >
                            <b-form-input
                              id="new-password"
                              v-model="form.password"
                              :state="errors.length > 0 ? false : null"
                              class="form-control-merge"
                              :type="passwordFieldType"
                              name="new-password"
                              autocomplete="new-password"
                              placeholder="············"
                              :placeholder="$t('password')"
                            />
                            <span v-if="!form.password" class="required-placeholder-asterisk text-danger" :style="getRequiredAsteriskStyle('password')">*</span>
                            <b-input-group-append is-text>
                              <feather-icon
                                class="cursor-pointer"
                                :icon="passwordToggleIcon"
                                @click="togglePasswordVisibility"
                              />
                            </b-input-group-append>
                          </b-input-group>
                          <small class="text-danger">{{ $t(errors[0]) }}</small>
                        </validation-provider>
                      </b-form-group>
                      <ul class="list-unstyled text-muted medium mt-1">
                        <li :class="{ 'text-success': hasNumber }">
                          ✔ {{ $t("oneNumeric") }}
                        </li>
                        <li :class="{ 'text-success': hasUppercase }">
                          ✔ {{ $t("oneCapitalLetter") }}
                        </li>
                        <li :class="{ 'text-success': hasSpecialChar }">
                          ✔ {{ $t("oneSpecialCharactar") }}
                        </li>
                        <li :class="{ 'text-success': hasValidLength }">
                          ✔ 8 {{ $t("characters") }}
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="row"> 
                    <div class="col-md-6 mb-1"></div>
                    <div class="col-md-6 mb-1">
                      <div class="captcha-section">
                        <div class="captcha-wrapper">
                          <img :src="captchaSrc" alt="captcha" class="mb-1"/>
                          <feather-icon
                            @click="fetchCaptcha"
                            class="cursor-pointer flex-shrink-0"
                            icon="RefreshCwIcon"
                            size="16"
                            style="color: #fff"
                          />
                        </div>
                        <div class="mb-1">
                          <b-form-group label-for="login-captcha">
                            <input
                              id="captcha"
                              v-model="captchaInput"
                              name="captcha"
                              class="form-control"
                              type="text"
                              :placeholder="'Captcha'"
                            />
                          </b-form-group>
                        </div>
                      </div>
                    </div>
                  </div>
                    
                  <div class="row">
                    <div class="col-md-6 mb-1"></div>
                    <div class="col-md-6 mb-1">
                      <b-form-checkbox v-model="isUserPoliciesAccepted" class="mb-1 text-white">
                        {{ $t("iAgreeToThe") }}
                        <a
                          href="https://dentaltwin.com/general-terms-and-conditions/"
                          class="text-primary"
                          target="_blank"
                        >
                          {{ $t("termsAndConditions") }} <span class="text-danger"> *</span>
                        </a>
                      </b-form-checkbox>
                      <div class="register-btn-wrapper mb-1">
                        <b-button
                          :disabled="isFormInvalid"
                          @click="createCustomer"
                          variant="primary"
                          block
                        >
                          {{ $t("register") }}
                        </b-button>
                      </div>
                    </div>
                  </div>
                </b-form>
              </validation-observer>
            </div>
          </div>
          
          <div class="custom-popup custom-success-popup" v-if="showRegisterModal">
            <div
              class="custom-popup-overlay"
              @click="showRegisterModal = false"
            ></div>
            <div class="custom-popup-content p-4 shadow-lg">
              <div class="custom-popup-bg">
                <img class="mb-2" src="@/assets/images/icons/mail.png" alt="" />
                <h2 class="mb-1">{{ $t("justOneMoreStepCheckYourEmail") }}!</h2>
                <h4>
                  {{ $t("pleaseConfirmYourEmailToCompleteRegistration") }}
                </h4>
              
                <p>
                  {{ $t("checkYourSpamOrPromotionsFolderToo") }}
                </p>
                <b-button
                  class="w-100 mt-3 px-4 py-2"
                  @click="refreshPage()"
                  variant="primary"
                  >{{ $t("continue") }}</b-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { detectBot } from "../services/botd.service";
import VuexyLogo from "@core/layouts/components/Logo.vue";
import Language from "@/components/Language.vue";
import TextInput from "@/components/TextInput.vue";
import PageHeader from "@/components/PageHeader.vue";
import countries from "@/assets/data/countries.json";
import MultiSelect from "vue-multiselect";
import NotificationService from "../services/notification.service";
import AuthService from "../services/auth.service";
import MultiSelectInput from "@/components/MultiSelectInput.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapGetters } from "vuex";
import { required, email } from "@validations";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import fileHandlerMixin from "@/mixins/fileHandlerMixin";
import { getBrowserLanguage, getCountryByLanguage, getLanguageByBrowserLanguage } from "@/utils/browserLanguage";
import {
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BFormCheckbox,
  BCardText,
  BCardTitle,
  BImg,
  BForm,
  BButton,
} from "bootstrap-vue";

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    VuexyLogo,
    Language,
    TextInput,
    PageHeader,
    MultiSelect,
    ValidationProvider,
    MultiSelectInput,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility, fileHandlerMixin],
  data() {
    const browserLanguage = getBrowserLanguage();
    const defaultCountry = getCountryByLanguage(browserLanguage, countries) || "";
    const availableLanguages = ["English", "French", "German", "Spanish", "Turkish"];
    const defaultLanguage = getLanguageByBrowserLanguage(browserLanguage, availableLanguages);
    
    return {
      countries,
      form: {
        first_name: "",
        last_name: "",
        companyName: "",
        addressLine1: "",
       // addressLine2: "",
        city: "",
        zipCode: "",
        country: defaultCountry,
        contactLanguage: defaultLanguage,
        // vatId: "",
        phone: "",
        password: "",
        email: "",
      },
      registerLink: "",
      customerId: "",
      isCustomerDisabled: false,
      languages: availableLanguages,
      portalBaseUrl: process.env.VUE_APP_PORTAL_BASEURL || "",
      showRegisterModal: false,
      showModal: false,
      captchaInput: "",
      image: {},
      referralId: "",
      isReferralInitialized: false,
      captchaSrc: "",
      captchaKey: "",
      password: "",
      userEmail: "",
      sideImg: require("@/assets/images/pages/login/login.png"),
      companyName: "",
      isValid: "",
      isUserPoliciesAccepted: false,
      windowWidth: typeof window !== "undefined" ? window.innerWidth : 1024,
      asteriskPositionTimers: [],
      email,
    };
  },
  computed: {
    ...mapGetters("customers", ["partners"]),
    // selectedPartnerName() {
    //   const id = (this.customerId && typeof this.customerId === 'object')
    //     ? this.customerId.id
    //     : this.customerId;
    //   const match = Array.isArray(this.partners)
    //     ? this.partners.find(p => p && p.id === id)
    //     : null;
    //   return match ? match.companyName : "";
    // },
    isFormInvalid() {
      return (
        !this.isPasswordValid ||
        !this.isUserPoliciesAccepted
      );
    },
    hasNumber() {
      return /\d/.test(this.form.password);
    },
    hasUppercase() {
      return /[A-Z]/.test(this.form.password);
    },
    hasSpecialChar() {
      return /[^a-zA-Z0-9]/.test(this.form.password);
    },
    hasValidLength() {
      return this.form.password.length >= 8;
    },
    isPasswordValid() {
      return (
        this.hasNumber &&
        this.hasUppercase &&
        this.hasSpecialChar &&
        this.hasValidLength
      );
    },
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
    isMobileRegisterText() {
      return this.windowWidth <= 800;
    },
    registerTitleKey() {
      return this.isMobileRegisterText
        ? "registerForFreeTestCasesTitleMobile"
        : "registerForFreeTestCasesTitle";
    },
    registerSubKey() {
      return this.isMobileRegisterText
        ? "registerForFreeTestCasesSubMobile"
        : "registerForFreeTestCasesSub";
    },
    registerDescriptionKey() {
      return this.isMobileRegisterText ? "authDescriptionMobile" : "authDescription";
    },
  },
  watch: {
    customerId() {
      if (!this.isReferralInitialized) return;
      this.saveReferralLink();
    }
  },
  async created() {
    
    if (!localStorage.getItem('lang')) {

      
      if (!localStorage.getItem('lang')) {
      const browserLang = getBrowserLanguage();
      const supportedLanguages = ['en', 'de', 'fr', 'es', 'tu'];
      
      if (supportedLanguages.includes(browserLang)) {
        this.$i18n.locale = browserLang;
        localStorage.setItem('lang', browserLang);
        document.documentElement.lang = browserLang;
      } else {
        this.$i18n.locale = 'en';
        localStorage.setItem('lang', 'en');
        document.documentElement.lang = 'en';
      }
    }
    }
    
    this.fetchCaptcha();
    this.$store.commit("showLoader", true);

    this.getPartnerCompanies();

    const referralKey =
      this.$route.query.referralId ||
      this.$route.query.companyId ||
      "admin_company";

    await this.$store
      .dispatch("customers/showReferralLink", referralKey)
      .then((res) => {
        let data = res?.data?.data;
        this.referralId = data.referralId;
        this.customerId = data.company;
        if (this.$route.query.referralId || this.$route.query.companyId) {
          this.isCustomerDisabled = data.company ? true : false;
        }
        if (data.image) {
          this.getImage(data.image.id, "fileSrc", this.image);
        }
      });
    this.isReferralInitialized = true;
    this.$store.commit("showLoader", false);
    this.$store.dispatch("globalConfiguration/getRegisterLink").then((res) => {
      this.registerLink = res?.data?.data?.redirectUrl ?? "";
    });
    
  },
  mounted() {
    this.setWidth();
    window.addEventListener("resize", this.setWidth);
    this.$nextTick(() => {
      this.$forceUpdate();
    });
    this.asteriskPositionTimers = [50, 150, 300, 700].map((delay) =>
      setTimeout(() => {
        this.$forceUpdate();
      }, delay)
    );
    if (typeof document !== "undefined" && document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => {
        this.$forceUpdate();
      });
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.setWidth);
    this.asteriskPositionTimers.forEach((timerId) => clearTimeout(timerId));
  },
  methods: {
    async getPartnerCompanies() {
      await this.$store.dispatch("customers/partnerCompanies", {
        page: 1,
        perPage: 25
      });
    },
    // async checkVatId() {
    //   this.isValid = "";
    //   if (!this.form.vatId || this.form.vatId.trim() === "") {
    //     return;
    //   }

    //   this.$store.commit("showLoader", true);

    //   await this.$store
    //     .dispatch("customers/checkVatId", {
    //       vatId: this.form.vatId,
    //     })
    //     .then((res) => {
    //       this.isValid = res?.data?.data?.valid;
    //       this.$store.commit("showLoader", false);
    //     })
    //     .finally(() => {
    //       this.$store.commit("showLoader", false);
    //     });
    // },
    async saveReferralLink() {
      if (this.customerId?.id) {
        this.$store.commit("showLoader", true);
        await this.$store
          .dispatch("customers/showReferralLink", this.customerId?.id ?? "")
          .then((res) => {
            let data = res?.data?.data;
            this.referralId = data.referralId;
            if (data.image) {
              this.getImage(data.image.id, "fileSrc", this.image);
            }

            // Update the URL without reloading the page
            const currentUrl = new URL(window.location.href);
            currentUrl.searchParams.set("referralId", this.referralId);
            window.history.replaceState({}, "", currentUrl);
          })
          .finally(() => {
            this.$store.commit("showLoader", false);
            });
      }
    },
    refreshPage() {
      window.location.href = this.registerLink ?? "https://dentaltwin.com/";
    },
    async fetchCaptcha() {
      await this.$store.dispatch("customers/fetchCaptcha").then((res) => {
        this.captchaSrc = res?.data?.key?.img;
        this.captchaKey = res?.data?.key?.key;
      });
    },
    setWidth() {
      this.windowWidth = window.innerWidth;
      const parent = this.$refs.authParentBox;
      const child = this.$refs.authChildBox;
      if (!parent || !child) return;
      child.style.width = `${parent.offsetWidth}px`;
      child.style.height = `${parent.offsetHeight}px`;
    },
    getRequiredAsteriskStyle(placeholderKey) {
      if (typeof document === "undefined") {
        return { "--asterisk-left": "20px" };
      }
      const placeholderText = this.$t(placeholderKey) || "";
      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");
      if (!context) {
        return { "--asterisk-left": "20px" };
      }
      context.font = "400 16px Montserrat, sans-serif";
      const placeholderWidth = context.measureText(String(placeholderText)).width;
      return { "--asterisk-left": `${16 + placeholderWidth + 10}px` };
    },
    async validateCustomerCreation() {
      if (!this.isPasswordValid) {
        return false;
      }
      if (!this.isUserPoliciesAccepted) {
        return false;
      }
      this.$store.commit("showLoader", true);
      const checkUserEmailResponse = await AuthService.checkUserEmail(this.form.email).catch(() => null);
      this.$store.commit("showLoader", false);
      if (checkUserEmailResponse?.data === true) {
        NotificationService.showError(this.$t("emailAlreadyExistsPleaseEnterAnotherEmail"));
        return false;
      }
      return true;
    },
    async createCustomer() {
      const botDetection = await detectBot();

      if (botDetection.bot) {
        NotificationService.showError(
          this.$t("somethingWentWrongPleaseContactSupport")
        );
        return;
      }
      this.$refs.simpleRules.validate().then(async (success) => {
        if (success) {
          const isCustomerCreationValid = await this.validateCustomerCreation();
          if (!isCustomerCreationValid) {
            return;
          }
          this.$store.commit("showLoader", true);
          await this.$store
            .dispatch("customers/registerCompany", {
              ...this.form,
              country: this.form.country?.name ?? "",
              referralLinkId: this.referralId,
              captcha: this.captchaInput,
              key: this.captchaKey,
            })
            .then(async (res) => {
              this.$store.commit("showLoader", false);
              this.showRegisterModal = true;
            })
            .catch((error) => {
                this.fetchCaptcha();
                this.captchaInput = "";
            })
            .finally(() => {
              this.$store.commit("showLoader", false);
            });
        }
      });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";

.captcha-section {
  min-width: 0;
  flex: 1 1 auto;

  @media (max-width: 575px) {
    width: 100%;
  }

  @media (min-width: 576px) {
    width: 100%;
  }
}

.captcha-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: nowrap;

  img {
    max-width: 100%;
    height: auto;
    flex-shrink: 1;
  }
}

.register-btn-wrapper {
  @media (max-width: 575px) {
    width: 100%;
  }

  @media (min-width: 576px) {
    min-width: 160px;
  }
}

.gap-2 {
  gap: 0.75rem;
}

.required-placeholder-input {
  position: relative;
}

.required-placeholder-asterisk {
  color: #ea5455;
}

.required-placeholder-asterisk.text-danger,
.input-group-append .required-placeholder-asterisk {
  color: #ea5455 !important;
}

.required-placeholder-input .required-placeholder-asterisk {
  position: absolute;
  left: var(--asterisk-left, 20px);
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
}

.custom-popup-bg {
  img {
    width: 150px;
  }
  h2 {
    font-size: 1.8rem;
  }
  h4 {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 8px;
  }
  p {
    font-size: 16px;
    margin-bottom: 8px;
  }
}
</style>
